<template>
    <div :class="['rounded-lg shadow-md p-4', $attrs.class]">
        <slot></slot>
    </div>
</template>
<script setup>


defineOptions({
  inheritAttrs: false
})
</script>


export default Card;
